// src/api.js
import { loadSession, saveSession, clearSession } from "./authStore";

const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

function url(path) {
  if (!path.startsWith("/")) path = `/${path}`;
  return API_BASE ? `${API_BASE}${path}` : path;
}

async function apiFetch(path, opts = {}) {
  const session = loadSession();

  // clone headers so we don't mutate caller's object
  const headers = { ...(opts.headers || {}) };

  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`;
  }

  const isFormData =
    typeof FormData !== "undefined" && opts.body instanceof FormData;

  // ✅ Only set JSON content-type when NOT FormData and body exists
  // (FormData must allow browser to set multipart boundary)
  if (!isFormData && opts.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  // ✅ Ensure we never force content-type for FormData
  if (isFormData && "Content-Type" in headers) {
    delete headers["Content-Type"];
  }
 // ✅ ADD THIS RIGHT HERE: remove later
  console.log("API_BASE:", API_BASE, "URL:", url(path));
  
  const res = await fetch(url(path), { ...opts, headers });

  // Token refresh retry (once)
  if (res.status === 401 && session?.refresh_token && !opts._retried) {
    const rr = await fetch(url("/api/auth/refresh"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: session.refresh_token }),
    });

    if (rr.ok) {
      const fresh = await rr.json();
      const updated = { ...session, ...fresh };
      const persist = !!session?.persist;   // ✅ keep same storage as original login
      saveSession(updated, persist);


      // retry original request once
      return apiFetch(path, { ...opts, _retried: true });
    }

    clearSession();
    window.location.reload(); // ✅ force app to go back to login cleanly
  }

  return res;
}

export async function login(username, password) {
  const res = await fetch(url("/api/auth/login"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error("Invalid credentials");
  return res.json();
}

export { apiFetch };
